/*
 * Created Date: 15-03-2024, 5:20:01 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Sat Mar 16 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import Image from 'mui-image'
import { useTranslation } from 'react-i18next'
import ErrorPageContainer from '../ErrorPageContainer'
import { useBreakpoints } from '@Core/hooks'

const Page403 = ({ msg = '' }) => {
	const { t } = useTranslation()
	const { mobile } = useBreakpoints()

	const renderContent = () => {
		return (
			<>
				<div className="w-[90%] sm:w-[600px] xl:w-[580px]">
					<Image src="/assets/images/errors/403.svg" alt="403" className="" />
				</div>

				<div className="flex flex-col items-center gap-20">
					<p className="text-[22px] m-0 leading-[28px] font-500 text-[#131214]">
						{t('Truy cập bị từ chối..')}
					</p>
					<p className="text-[18px] m-0 leading-[24px] font-500 text-[#5E5C63] text-center px-3">
						{msg ||
							t(
								'Bạn không có đủ quyền hạn để truy cập trang này, vui lòng liên hệ Admin để được hỗ trợ thêm.'
							)}
					</p>
					<p className="text-[16px] m-0 leading-[20px] font-500 text-[#9E9BA6] text-center">
						{t('Lỗi 403: Forbidden')}
					</p>
				</div>
			</>
		)
	}

	return <>{mobile ? <>{renderContent()}</> : <ErrorPageContainer>{renderContent()}</ErrorPageContainer>}</>
}
export default Page403
